export default class sectionCurrent {

  constructor() {
    this.section = document.querySelectorAll('.js-section');
    this.navElm = document.getElementById('js-nav');
    this.nav = document.querySelectorAll('#js-nav a');
    this.moreElm = document.querySelector('.p-worksSingleMore');
    this.currentClass = 'is-current';
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    this.posY = window.pageYOffset;
    this.posBottom = this.posY + this.winH;
    this.scrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
    this.adjust = 100; // 画面下の調整値
    this.scrollBottom = this.scrollY + this.winH - this.adjust;
    this.moreTop = this.moreElm.getBoundingClientRect().top + this.scrollY;
    this.secPos = [];
    this.init();
  }

  init() {
    let _self = this;
    _self.rect();
    _self.resizeRect();
    _self.addNavClass();
    _self.setScroll();
  }

  // スクロール処理
  setScroll() {
    let _self = this;
    let ticking = false;

    function setScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          ticking = false;
          _self.scrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
          _self.scrollBottom = _self.scrollY + _self.winH - _self.adjust;
          _self.moreTop = _self.moreElm.getBoundingClientRect().top + _self.scrollY;
          _self.resizeScroll();
          _self.resizeRect();
          _self.addNavClass();
          if (_self.scrollBottom + _self.adjust > _self.moreTop) {
            _self.navElm.classList.remove('is-view');
          }
        });
        ticking = true;
      }
    }
    document.addEventListener('scroll', setScroll, !document.documentMode ? {
      passive: true
    } : false);
  }

  // ウインドウ変動によるセクションの座標再計算
  resizeRect() {
    let _self = this;
    let ticking = false;

    function resizeRect() {
      if (!ticking) {
        requestAnimationFrame(function () {
          ticking = false;
          _self.rect();
        });
        ticking = true;
      }
    }
    window.addEventListener('resize', resizeRect, !document.documentMode ? {
      passive: true
    } : false);
  }

  // ウインドウ変動によるスクロール値の再計算
  resizeScroll() {
    let _self = this;
    let ticking = false;

    function resizeScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          ticking = false;
          _self.winH = window.innerHeight;
          _self.scrollY = window.scrollY;
          _self.scrollBottom = _self.scrollY + _self.winH;
        });
        ticking = true;
      }
    }
    window.addEventListener('resize', resizeScroll, !document.documentMode ? {
      passive: true
    } : false);
  }

  // セクションの座標を取得して配列に入れる
  rect() {
    let _self = this;
    let rect;
    let rectPosY;
    let moreTop;
    // 配列の再計算時は一度配列を空にする
    if (_self.secPos.length > 0) {
      _self.secPos = [];
    }
    for (const _sec of _self.section) {
      rect = _sec.getBoundingClientRect();
      rectPosY = rect.top + _self.scrollY;
      _self.secPos.push(rectPosY);
    }
    // footerの座標取得
    moreTop = _self.moreElm.getBoundingClientRect().top + _self.scrollY;
  }

  // 座標範囲でインデックス番号を返す
  getIndexPos() {
    let _self = this;
    let secIndex;
    let _ary = [];
    for (let index = 0; index < _self.secPos.length; index++) {
      if (_self.scrollBottom > _self.secPos[index]) {
        _ary.push(index);
      } else {
        break;
      }
    }
    secIndex = _ary.length == 0 ? null : _ary.reduce((a, b) => Math.max(a, b)); // indexの最大値を取得
    return secIndex;
  }

  // ナビゲーションの該当セクションにclassを付与
  addNavClass() {
    let _self = this;
    // 要素が無い時はClassを削除
    if (_self.getIndexPos() == null) {
      for (const _nav of _self.nav) {
        if (_nav.classList.contains(_self.currentClass)) {
          _nav.classList.remove(_self.currentClass);
        }
      }
      _self.navElm.classList.remove('is-view');
      return;
    }
    if (_self.nav[_self.getIndexPos()].classList.contains(_self.currentClass)) {
      _self.navElm.classList.add('is-view');
      return;
    } else {
      for (const _nav of _self.nav) {
        _nav.classList.remove(_self.currentClass);
        _self.nav[_self.getIndexPos()].classList.add(_self.currentClass);
        // 背景白の時黒くする（セクション毎に変えるなどの場合は処理の再考が必要）
        if (_self.getIndexPos() > 1) {
          _self.navElm.classList.add('is-black');
        } else {
          _self.navElm.classList.remove('is-black');
        }
      }
    }
  }

}